import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import cn from 'classnames';
import b from 'b_';
import { ObservableTextfield } from '../Textfield';
import Button from '../Button';
import Actions from '../Actions/Actions';
import DatepickerStore from '../../stores/DatepickerStore';

import './Datepicker.css';

const block = b.lock('Datepicker');

class Datepicker extends Component {
    static propTypes = {
        store: DatepickerStore.PropType,
        inputClassName: PropTypes.string,
        label: PropTypes.string,
        labelClassName: PropTypes.string,
    };

    renderCalendar = () => {
        const store = this.props.store;
        const { selectedDay } = store;
        return <Fragment>
            <div className={block('Month')}>
                <Button
                    className={block('MonthNav')}
                    icon="keyboard_arrow_left"
                    onClick={store.showPrevMonth}
                    disabled={store.checkMonthAvailability()}
                />
                <div className={block('MonthTitle')}>{store.monthTitle}</div>
                <Button
                    className={block('MonthNav')}
                    icon="keyboard_arrow_right"
                    onClick={store.showNextMonth}
                />
            </div>
            <div className={block('Days')}>
                {store.daysOfWeek.map((dayTitle, index) => <div
                    key={'wd' + index}
                    className={block('Day', { type: 'weekday' })}
                >{dayTitle}</div>)}
                {store.daysOfMonth.map((dayTitle, index) => (dayTitle ? <Button
                    key={dayTitle + ' ' + index}
                    className={block('Day', { type: 'day', active: dayTitle === selectedDay })}
                    disabled={store.checkDayAvailability(dayTitle)}
                    onClick={() => store.setDay(dayTitle)}
                >{dayTitle}</Button> : <div
                    key={dayTitle + ' ' + index}
                    className={block('Day', { type: 'padding' })}
                />))}
            </div>
            <Actions
                className={block('Actions')}
                wrapperClassName={block('ActionsButtonWrapper')}
            >
                <Button
                    className={block('ActionButton')}
                    onClick={store.onCancel}
                    raised
                    secondaryWhite
                    fullWidth
                >CANCEL</Button>
                <Button
                    className={block('ActionButton')}
                    onClick={store.onApply}
                    raised
                    primary
                    fullWidth
                >APPLY</Button>
            </Actions>
        </Fragment>;
    };

    render() {
        const { store } = this.props;
        return <div className={cn(block(), this.props.className)}>
            <ObservableTextfield
                readOnly
                store={store.selectedDate}
                onClick={store.toggleCalendar}
                inputClassName={cn(this.props.inputClassName, block('InputField', { Closed: store.isCalendarOpen }))}
                label={this.props.label}
                labelClassName={this.props.labelClassName}
            />
            {store.isCalendarOpen ? <div
                className={block('DropdownContent')}
                onClose={store.closeCalendar}
            >{this.renderCalendar()}</div> : null}
        </div>;
    }
}

export default observer(Datepicker);
